export const UAE_TIME_ZONE = 'Asia/Dubai'

/** 列表/看板金额：不保留小数，四舍五入为整数展示 */
export function formatMoneyInt(n?: number | string | null, fallback = '—'): string {
  if (n == null || n === '')
    return fallback
  const x = typeof n === 'string' ? Number(n.replace(/,/g, '').trim()) : Number(n)
  if (!Number.isFinite(x))
    return fallback
  return Math.round(x).toLocaleString('zh-CN', { maximumFractionDigits: 0, minimumFractionDigits: 0 })
}

function partsInUae(date: Date) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: UAE_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date)
  const m = Object.fromEntries(parts.map(p => [p.type, p.value])) as Record<string, string>
  return {
    YYYY: m.year,
    MM: m.month,
    DD: m.day,
    HH: m.hour,
    mm: m.minute,
    ss: m.second,
  }
}

export function formatDateTime(value?: Date | number | string | null, fallback = '-', fmt = 'YYYY-MM-DD HH:mm:ss'): string {
  if (value == null || value === '') return fallback
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return fallback
  const p = partsInUae(d)
  return fmt.replace(/YYYY|MM|DD|HH|mm|ss/g, k => p[k as keyof typeof p])
}

/** 服务端常见 epoch 秒，统一按阿联酋时间展示 */
export function formatEpoch(sec?: number | null, fallback = '-') {
  if (sec == null || sec <= 0) return fallback
  return formatDateTime(sec * 1000, fallback, 'YYYY-MM-DD HH:mm')
}

/** 后端 LocalDate/LocalDateTime 字符串本身已按站点时区生成，这里只统一展示格式，不再按浏览器时区偏移。 */
export function formatServerDateText(s?: string | null, fallback = '—') {
  if (!s) return fallback
  const raw = String(s).trim()
  if (!raw) return fallback
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw
  const normalized = raw.replace('T', ' ').replace(/\.\d+$/, '')
  return normalized.length >= 16 ? normalized.slice(0, 16) : normalized
}
